import { render, staticRenderFns } from "./MailerSettings.vue?vue&type=template&id=5c0cb569&scoped=true&"
import script from "./MailerSettings.vue?vue&type=script&lang=js&"
export * from "./MailerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cb569",
  null
  
)

export default component.exports